import { ColDef, ValueFormatterParams, ValueGetterParams } from 'ag-grid-community';
import { TimeFormat } from '@benzinga/date-utils';
import { DateTime } from 'luxon';
import { NO_VALUE } from '../../../Ticker';

const checkDateTime = (valueA: string, valueB: string): number => {
  const dateTimeA = DateTime.fromJSDate(new Date(valueA));
  const dateTimeB = DateTime.fromJSDate(new Date(valueB));

  if (!dateTimeA.isValid || !dateTimeB.isValid) {
    return 0;
  }

  if (dateTimeA < dateTimeB) {
    return -1;
  } else if (dateTimeA > dateTimeB) {
    return 1;
  }
  return 0;
};

export interface DateColDefTimeSettings {
  timeFormat: TimeFormat;
  timeOffset: number;
  timezone?: string;
}

export const DateColDef = (colDef: ColDef, { timeOffset }: DateColDefTimeSettings): ColDef => ({
  cellStyle: { textAlign: 'left' },
  comparator: checkDateTime,
  filter: 'agDateColumnFilter',
  filterParams: {
    comparator: (filterLocalDateAtMidnight: Date, cellValue: string) => {
      if (!cellValue) return -1;
      const cellDate = new Date(cellValue);
      if (isNaN(cellDate.getTime())) return -1;

      const diff = cellDate.setHours(0, 0, 0, 0) - filterLocalDateAtMidnight.getTime();
      return diff < 0 ? -1 : diff > 0 ? 1 : 0;
    },
  },
  filterValueGetter: ({ colDef: { field = 'time' }, data }: ValueGetterParams) => {
    const value = data[field];

    return DateTime.fromISO(value).toJSDate();
  },
  valueFormatter: ({ value }: ValueFormatterParams): string => (value !== 0 ? value : NO_VALUE),
  valueGetter: ({ colDef: { field = 'time' }, data }: ValueGetterParams) => {
    const value = String(data[field]);
    if (!value) return NO_VALUE;
    const hasTime = value.includes('T');
    const dateTime = DateTime.fromISO(value).isValid
      ? DateTime.fromISO(value)
      : DateTime.fromFormat(value, 'MM/dd/yyyy');

    if (!dateTime.isValid) return NO_VALUE;
    return hasTime
      ? dateTime.plus({ minutes: timeOffset }).toFormat('yyyy-MM-dd HH:mm:ss')
      : dateTime.toFormat('yyyy-MM-dd');
  },
  ...colDef,
});
